var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('sc-streaming',{key:_vm.reloadKey,attrs:{"streams":_vm.localStreams,"stream-settings":_vm.streamSettings,"version":_vm.version},on:{"reload-stream":_vm.reloadStream}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }